import PosActions from '../../../actions/PosActions';
import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';
import PosStore from '../../../stores/PosStore';
import PosCartStore from '../../../stores/PosCartStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

class EditCartItem extends React.Component {

    constructor(props) {
        super(props);

        var item = this.props.item;

        this.state = {
            price           : item.WgtCnt === 'Qty' ? item.TotalCost / item.QtyAllocated : item.TotalCost / item.Grams,
            discount        : item.DiscountAmt / item.QtyAllocated,
            supply          : item.DaysSupply,
            instructions    : item.Instructions,
            pin             : '',

            priceChanged    : false,
            discountChanged : false,

            autoPrintLabels : PosStore.getState().autoPrintLabels,
            labels          : PosStore.getState().labels,
            defaultLabel    : PosStore.getState().defaultLabel,
            defaultLabelPrinter: PosStore.getState().labelPrinter
        };

        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.onPosCartStoreChange = this.onPosCartStoreChange.bind(this);
        this.saveCartEdit = this.saveCartEdit.bind(this);
        this.checkManagerPin = this.checkManagerPin.bind(this);
        this.onPriceChange = this.onPriceChange.bind(this);
        this.onDiscountChange = this.onDiscountChange.bind(this);
        this.onSupplyChange = this.onSupplyChange.bind(this);
        this.onInstructionsChange = this.onInstructionsChange.bind(this);
    }

    componentWillMount() {
        PosStore.addChangeListener(this.onPosStoreChange);
        PosCartStore.addChangeListener(this.onPosCartStoreChange);
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
        PosCartStore.removeChangeListener(this.onPosCartStoreChange);
    }

    onPosStoreChange() {
        this.setState({
            autoPrintLabels : PosStore.getState().autoPrintLabels,
            labels          : PosStore.getState().labels,
            defaultLabel    : PosStore.getState().defaultLabel,
            defaultLabelPrinter: PosStore.getState().labelPrinter
        });
    }

    onPosCartStoreChange() {
        var cart = PosCartStore.getState().cart;
        var item = false;

        for (var i=0; i<cart.length; i++) {
            if (cart[i].SerialNo === this.props.item.SerialNo) {
                item = cart[i];
            }
        }
        
        if (item) {
            this.setState({
                price           : item.WgtCnt === 'Qty' ? item.TotalCost / item.QtyAllocated : item.TotalCost / item.Grams,
                discount        : item.DiscountAmt / item.QtyAllocated,
                supply          : item.DaysSupply,
                instructions    : item.Instructions,
                pin             : '',
            });
        }
    }

    checkManagerPin() {
        var self = this;

        if (this.state.pin.length < 1) {
            NotificationActions.alert('Manager PIN Missing');
            return;
        }

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, UserStore.getApiData({
            PinCode : this.state.pin
        })).then(res => {
            if (res.Data[0].MgrPermission === true) {
                self.saveCartEdit();
            } else {
                NotificationActions.alert('Invalid PIN');
            }
        });
    }

    saveCartEdit() {
        var item  = this.props.item;
        var guest = this.props.guest;

        var selectedLocation     = UserStore.getState().selectedLocation;

        if (!selectedLocation.DiscountOverPrice && this.state.discount > item.TotalCost / item.QtyAllocated) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Discount can not be greater than unit price ($'+item.TotalCost / item.QtyAllocated+')'
            });
            return;
        }

        var formData            = UserStore.getApiData();
        formData.ProductId      = item.ProductId;
        formData.SerialNo       = item.SerialNo;
        formData.UnitPrice      = this.state.price;
        formData.DiscountAmt    = Math.abs(this.state.discount);
        formData.Instructions   = this.state.instructions;
        formData.DaysSupply     = this.state.supply;
        formData.ShipmentId     = guest.ShipmentId;

        PosCartActions.editItem(formData, guest)
        .then(res => {
            this.setState({ 
                priceChanged: false, 
                discountChanged: false 
            });
        });
    }

    onPriceChange(e) {
        this.setState({ price : e.target.value, priceChanged: true });
    }

    onDiscountChange(e) {
        this.setState({ discount : e.target.value, discountChanged: true });
    }

    onSupplyChange(e) {
        this.setState({ supply : e.target.value ? _.round(e.target.value) : '' });
    }

    onInstructionsChange(e) {
        this.setState({ instructions : e.target.value });
    }

    render() {
        var item  = this.props.item;
        var guest = this.props.guest;

        var labelPrinters = PosStore.getState().availableLabelPrinters;
        var selectedLocation = UserStore.getState().selectedLocation;
        var editCartPartial = selectedLocation.EditCartPartial;
        var priceOrDiscountChanged = (this.state.priceChanged || this.state.discountChanged);

        return (
            <div className='edit-cart-item'>

                { !editCartPartial &&
                    <div className='edit-cart-item__input'>
                        <div className='edit-cart-item__title'>
                            Price Per Item
                        </div>

                        <input
                            type='text'
                            disabled={guest.IsPaid}
                            className='input-text-1'
                            value={this.state.price}
                            onChange={this.onPriceChange} />
                    </div>
                }

                { !editCartPartial &&
                    <div className='edit-cart-item__input'>
                        <div className='edit-cart-item__title'>
                            Discount Per Item
                        </div>

                        <input
                            type='text'
                            disabled={guest.IsPaid}
                            className='input-text-1'
                            value={this.state.discount}
                            onChange={this.onDiscountChange} />
                    </div>
                }

                { !editCartPartial && !selectedLocation.UseMn &&
                    <div className='edit-cart-item__input'>
                        <div className='edit-cart-item__title'>
                            Days Supply Per Item 
                        </div>

                        <input
                            type='number'
                            className='input-text-1'
                            value={this.state.supply}
                            onChange={this.onSupplyChange} />
                    </div>
                }

                { !editCartPartial && selectedLocation.UseMn &&
                    <span>
                    <div className='edit-cart-item__input'>
                        <div className='edit-cart-item__title'>
                            Days Per Item
                        </div>

                        <input
                            type='number'
                            disabled
                            className='input-text-1'
                            value={this.state.supply}
                            onChange={(e) => this.setState({ supply : e.target.value })} />
                    </div>
                    <div className='edit-cart-item__input'>
                        <div className='edit-cart-item__title'>
                            Days Total 
                        </div>

                        <input
                            type='number'
                            className='input-text-1'
                            value={this.state.supply ? _.ceil(this.state.supply * this.props.item.QtyAllocated) : ''}
                            onChange={(e) => {
                                if(e.target.value !== null && e.target.value !== '') {
                                    this.setState({ supply : _.floor(e.target.value / this.props.item.QtyAllocated, 2) });
                                } else {
                                    this.setState({ supply : e.target.value });
                                }
                            }} />
                    </div>
                    </span>
                }

                { !editCartPartial &&
                    <div className='edit-cart-item__instructions'>
                        <div className='edit-cart-item__title'>
                            Instructions
                        </div>

                        <textarea
                            value={this.state.instructions}
                            onChange={this.onInstructionsChange} />
                    </div>
                }

                <div className='pos-edit-item__label'>
                    <div className='edit-cart-item__title'>
                        Label
                    </div>
                    <select
                        value={this.state.defaultLabel}
                        onChange={(e) => { PosActions.setDefaultLabel(e.target.value); }}
                        id='edit-item'
                        className='input-text-1'>

                        <option value='-'>-</option>
                        { this.state.labels && this.state.labels.map((label, i) => {

                            return (
                                <option
                                    value={label.id}
                                    key={'label-'+label.id}>
                                    {label.LabelDescription}
                                </option>
                            );
                        })}
                    </select>
                </div>

                <div className='pos-edit-item__printer'>
                    <div className='edit-cart-item__title'>
                        Printer
                    </div>
                    <select
                        value={(this.state.defaultLabelPrinter || {}).PrinterId}
                        onChange={(e) => { PosActions.setLabelPrinter(e.target.value) }}
                        id='edit-printer'
                        className='input-text-1'>

                        <option value='-'>-</option>
                        { labelPrinters.map((p, i) => {
                            return (
                                <option
                                    value={p.PrinterId}
                                    key={'label-'+p.PrinterId}>
                                    {p.Name}
                                </option>
                            );
                        })}
                    </select>
                </div>

                <div
                    className='edit-cart-item__save btn-green'
                    onClick={selectedLocation.POSEditCartMgrPassword && priceOrDiscountChanged ? this.checkManagerPin : this.saveCartEdit}>

                    SAVE
                </div>

                {selectedLocation.POSEditCartMgrPassword && priceOrDiscountChanged && 
                    <input
                        type='password'
                        className='edit-cart-item__password'
                        placeholder='PIN'
                        value={this.state.pin}
                        onChange={e => { this.setState({ pin : e.target.value }); }} />
                }
            </div>
        );
    }
}

export default EditCartItem;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/EditCartItem.react.jsx